export default "__VITE_ASSET__DtyML7RN__"